import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setErrore('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (e) {
      setErrore('Credenziali non valide');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ width: 160, height: 100, borderRadius: 20, background: '#ffffff', border: '1px solid #334155', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: 12 }}>
            <img src="/logo.jpg" alt="Nerosicilia" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          </div>
          <h1 style={{ color: '#f1f5f9', fontSize: 28, fontWeight: 800, margin: 0 }}>Nerosicilia HR</h1>
          <p style={{ color: '#64748b', fontSize: 14, margin: '6px 0 0' }}>Gestione Risorse Umane</p>
        </div>
        <div style={{ background: '#1e293b', borderRadius: 20, padding: 28, border: '1px solid #334155' }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, fontWeight: 600, marginBottom: 6, letterSpacing: '0.08em' }}>EMAIL</label>
          <input value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@azienda.it"
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '12px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 15, marginBottom: 16, boxSizing: 'border-box', outline: 'none' }} />
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 12, fontWeight: 600, marginBottom: 6, letterSpacing: '0.08em' }}>PASSWORD</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '12px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 15, marginBottom: 8, boxSizing: 'border-box', outline: 'none' }} />
          {errore && <p style={{ color: '#ef4444', fontSize: 13, margin: '8px 0' }}>{errore}</p>}
          <button onClick={handleLogin} disabled={loading}
            style={{ width: '100%', padding: 13, background: loading ? '#334155' : 'linear-gradient(135deg, #f59e0b, #ef4444)', border: 'none', borderRadius: 12, color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </div>
      </div>
    </div>
  );
}
